// 从环境变量获取服务模块路径，如果没有则使用默认值
export const mainApp = process.env.REACT_APP_API_MAIN_APP || "/bg";
export const authServiceApp = process.env.REACT_APP_API_AUTH_SERVICE || "/auth";
export const adminServiceApp = process.env.REACT_APP_API_ADMIN_SERVICE || "/website";
export const reportServiceApp = process.env.REACT_APP_API_REPORT_SERVICE || "/report";
export const dispsetServiceApp = process.env.REACT_APP_API_DISPSET_SERVICE || "/dispset";
export const financialServiceApp = process.env.REACT_APP_API_FINANCIAL_SERVICE || "/financial";
export const activityServiceApp = process.env.REACT_APP_API_ACTIVITY_SERVICE || "/activity";
export const memberServiceApp = process.env.REACT_APP_API_MEMBER_SERVICE || "/member";
export const mallServiceApp = process.env.REACT_APP_API_MALL_SERVICE || "/mall";
export const dataServiceApp = process.env.REACT_APP_API_DATA_SERVICE || "/data";
export const imServiceApp = process.env.REACT_APP_API_IM_SERVICE || "/im";
export const aiServiceApp = process.env.REACT_APP_API_AI_SERVICE || "/ai";
